<template>

  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <b-overlay
      :show="loading"
      rounded="sm"
      :variant="$store.state.appConfig.layout.skin === 'dark' ? 'dark' : 'light'"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Items</label>
            <div class="d-inline-block ml-50 mr-1">
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="w-100 d-inline-block"
              />
            </div>
            <b-button
              variant="primary"
              class="d-inline-block ml-auto ml-md-0"
              @click="dialog = true"
            >
              Nuevo
            </b-button>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <b-button
                variant="outline-primary"
                class="ml-2"
                @click="dialogExport = true"
              >
                Exportar
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-modal
        v-model="dialog"
        title="Datos del Usuario"
        hide-footer
      >
        <add-edit
          :item.sync="editedItem"
          :loading.sync="loading"
          @close="close"
          @save="save"
        />
      </b-modal>

      <b-modal
        v-model="dialogDelete"
        title="Eliminar Usuario"
        hide-footer
      >
        <delete-data
          :id-item="editedItem.id"
          :loading.sync="loading"
          @close="close"
          @delete="remove"
        />
      </b-modal>

      <b-modal
        v-model="dialogExport"
        title="Exportar datos"
        hide-footer
      >
        <export-data
          :loading.sync="loading"
          @close="close"
          @export="exportData"
        />
      </b-modal>

      <b-table
        ref="refDataTable"
        :items="fetchData"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No hay datos disponibles."
        :sort-desc.sync="isSortDirDesc"
        class="position-relative"
        :loading="loading"
        loading-text="Cargando..."
      >

        <!-- Column: Name -->
        <template #cell(name)="data">
          <b-link
            class="font-weight-bold"
            @click="editItem(data.item)"
          >
            {{ data.value }}
          </b-link>
        </template>

        <!-- Column: Status
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="data.item.status === 'active' ? 'light-success' : 'light-danger'"
          >
            {{ data.item.status === 'active' ? 'Activo' : 'No Activo' }}
          </b-badge>
        </template>
        -->

        <!-- Column: Notifications -->
        <template #cell(notification)="data">
          <div class="d-flex align-items-center justify-content-center">
            <b-form-checkbox
              :id="`user-row-${data.item.id}-notification-alert`"
              :checked="data.item.notification"
              disabled
              class="m-0"
            />
            <b-tooltip
              title="Notificaciones"
              class="cursor-pointer"
              :target="`user-row-${data.item.id}-notification-alert`"
            />
          </div>
        </template>

        <!-- Column: Enabled -->
        <template #cell(enabled)="data">
          <div class="d-flex align-items-center justify-content-center">
            <b-form-checkbox
              :id="`user-row-${data.item.id}-enabled-checkbox`"
              :checked="data.item.enabled"
              disabled
              class="m-0"
            />
            <b-tooltip
              title="Habilitado"
              class="cursor-pointer"
              :target="`user-row-${data.item.id}-enabled-checkbox`"
            />
          </div>
        </template>

        <!-- Column: AuthType -->
        <template #cell(authType)="data">
          {{ resolveAuthTypeVariant(data.item.authType).label }}
        </template>

        <!-- Column: Role -->
        <template #cell(role)="data">
          {{ resolveRoleVariant(data.item.role).label }}
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="d-flex align-items-center justify-content-center text-nowrap">
            <feather-icon
              :id="`user-row-${data.item.id}-edit-icon`"
              icon="EditIcon"
              class="cursor-pointer mr-1"
              size="16"
              @click="editItem(data.item)"
            />
            <b-tooltip
              title="Editar"
              class="cursor-pointer"
              :target="`user-row-${data.item.id}-edit-icon`"
            />

            <feather-icon
              :id="`user-row-${data.item.id}-trash-icon`"
              icon="TrashIcon"
              class="cursor-pointer"
              size="16"
              @click="deleteItem(data.item)"
            />
            <b-tooltip
              title="Eliminar"
              class="cursor-pointer"
              :target="`user-row-${data.item.id}-trash-icon`"
            />
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} items</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalData"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
      <template #overlay>
        <!-- Show loading spinner if loading -->
        <loading-logo
          v-if="loading"
          class="mt-4 mb-4"
        />
      </template>
    </b-overlay>
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable,
  BPagination, BTooltip, BFormCheckbox, BOverlay, BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import DeleteData from '@/views/utils/DeleteData.vue'
import ExportData from '@/views/utils/ExportData.vue'
import exportFromJSON from 'export-from-json'
import AddEdit from './AddEdit.vue'
import userStoreModule from './userStoreModule'
import allFetchData from './allFetchData'
import LoadingLogo from '../miscellaneous/LoadingLogo.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BTooltip,
    BFormCheckbox,
    BOverlay,
    BLink,
    vSelect,
    AddEdit,
    DeleteData,
    ExportData,
    LoadingLogo,
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'users'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const {
      fetchData,
      fetchAdd,
      fetchUpdate,
      fetchDelete,
      fetchExport,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTable,
      loading,
      statusFilter,
      resolveAuthTypeVariant,
      resolveRoleVariant,
      refetchData,
    } = allFetchData()

    return {
      fetchData,
      fetchAdd,
      fetchUpdate,
      fetchDelete,
      fetchExport,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTable,
      loading,
      statusFilter,
      resolveAuthTypeVariant,
      resolveRoleVariant,
      refetchData,
    }
  },
  data() {
    return {
      statusOptions: [
        { value: 'active', text: 'Activo' },
        { value: 'inactive', text: 'No Activo' },
      ],
      dialog: false,
      dialogDelete: false,
      dialogExport: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        name: '',
        email: '',
        role: 'admin',
        enabled: true,
        notification: true,
        authType: 'microsoft',
      },
      defaultItem: {
        id: null,
        name: '',
        email: '',
        role: 'admin',
        enabled: true,
        notification: true,
        authType: 'microsoft',
      },
    }
  },
  watch: {
    dialog(val) {
      // eslint-disable-next-line no-unused-expressions
      val || this.close()
    },
  },
  methods: {
    add() {
      this.fetchAdd(this.editedItem, () => {
        this.close()
      })
    },
    edit() {
      this.fetchUpdate(this.editedItem, () => {
        this.close()
      })
    },
    remove() {
      this.fetchDelete(this.editedItem.id, () => {
        this.close()
      })
    },
    editItem(item) {
      this.editedItem = { ...item }
      this.dialog = true
    },
    deleteItem(item) {
      this.editedItem = { ...item }
      this.dialogDelete = true
    },
    save() {
      if (this.editedItem.id > 0) {
        this.edit()
      } else {
        this.add()
      }
    },
    close() {
      this.dialog = false
      this.dialogExport = false
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.editedIndex = -1
      })
    },
    exportData() {
      this.fetchExport(this.editedItem, res => {
        try {
          const fileName = 'Listado de Usuarios'
          const exportType = exportFromJSON.types.xls
          const data = res.map(item => ({
            nombre: item.name,
            correo_electrónico: item.email,
            autenticación: this.resolveAuthTypeVariant(item.authType).label,
            rol: this.resolveRoleVariant(item.role).label,
            habilitado: item.enabled ? 'Si' : 'No',
            notificacion: item.notification ? 'Si' : 'No',
            fecha_creacion: item.createdAt,
            fecha_actualizacion: item.updatedAt,
          }))
          if (data) exportFromJSON({ data, fileName, exportType })
        } catch (error) {
          console.log('error', error)
        }
        this.close()
      })
    },
  },
}
</script>
